/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete, {
  geocodeByAddress
} from 'react-places-autocomplete';
import { uniqueID } from '../../../utils/helpers';

class AddressBadging extends Component {
  autoCompleteRef = React.createRef();

  constructor(props) {
    super(props);
    this.ID = uniqueID('map');
    const { isRequired, updateFieldErrors, answer } = this.props;
    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }

    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
    this.state = {
      address: '',
      street: ''
    };
  }

  async componentDidMount() {
    // const { airportInfo } = this.props;
    // if (airportInfo && Object.keys(airportInfo).length > 0) {
    //   this.handleInitialMap();
    // }
    if (this.props.fieldId === 'street') {
      this.setState({
        address: this.props.answer?.street
      });
    } else {
      this.setState({
        address: this.props.answer?.fulladdress
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.answer!== this.props.answer) {
      if (this.props.fieldId === 'street') {
        this.setState({
          address: this.props.answer?.street
        });
      }
      if (this.props.fieldId === 'place_of_birth') {
        this.setState({
          address: this.props.answer?.fulladdress
        });
      }
    }
  }

  handleAnswerChanged = (value, fieldId) => {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      updateFieldErrors
    } = this.props;

    handleValueChange(value, fieldId);
    let updatedErrors = [];
    if (value === '' || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  };

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (selected_address) => {
    const { fieldId, Badging, systemGenerated } = this.props;
    geocodeByAddress(selected_address)
      .then(results => results[0])
      .then((addressObject) => {
          const streetAddress = addressObject.address_components;
          let streetValue = '';
          let cityValue = '';
          let stateValue = '';
          let zipCodeValue = '';
          let countryValue = {};
          let routetValue = '';
          for (let i = 0; i < streetAddress.length; i++) {
            if (streetAddress[i].types.indexOf('street_number')!== -1) {
              streetValue = streetAddress[i].long_name;
            }
            if (streetAddress[i].types.indexOf('route')!== -1) {
              routetValue = streetAddress[i].long_name;
            }
            if (streetAddress[i].types.indexOf('locality')!== -1) {
              cityValue = streetAddress[i].long_name;
            }
            if (streetAddress[i].types.indexOf('administrative_area_level_1')!== -1) {
              stateValue = streetAddress[i].long_name;
            }
            if (streetAddress[i].types.indexOf('postal_code')!== -1) {
               zipCodeValue = streetAddress[i].long_name;
            }
            if (streetAddress[i].types.indexOf('country')!== -1) {
              countryValue = { label: streetAddress[i].long_name, value: streetAddress[i].short_name };
           }
          }
          const address = (Badging && systemGenerated === false) ? selected_address : `${cityValue},${stateValue}`;

          const data={
            street: routetValue ? `${streetValue} ${routetValue}`: streetValue,
            city: cityValue,
            state: stateValue,
            zip: zipCodeValue,
            country: countryValue,
            fulladdress: address
          };
          this.setState({ address: fieldId === 'street' ? data.street: address, street: data.street });
          if (address) this.handleAnswerChanged(data, fieldId);
          if (Badging && systemGenerated === false) {
            this.setState({
              address: selected_address
            });
          }
        });
  };

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: 'Search Places ...',
                className: 'location-search-input'
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

AddressBadging.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  answer: PropTypes.arrayOf(PropTypes.number),
  defaultLocation: PropTypes.arrayOf(PropTypes.number)
};

AddressBadging.defaultProps = {
  answer: undefined,
  defaultLocation: undefined
};

export default AddressBadging;
